package com.wintermar.inspection.feature.presentation.inspection.answer.widget.page_info

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel

@Composable
actual fun PageInfoModal(
    show: Boolean,
    currentPage: Int,
    data: InspectionTemplateModel,
    title: String,
    onDismiss: () -> Unit,
    onClick: (pageOrder: Int) -> Unit
) {
    ModalDialog(
        title = title,
        show = show,
        action = ModalAction.default().copy(
            withBackgroundHeader = true
        ),
        onDismiss = onDismiss
    ) {
        PageInfo(
            currentPage = currentPage,
            data = data,
            onClick = onClick
        )
    }
}
